<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4 ml-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="User Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.employee_code" outlined label="Employee Code" prepend-inner-icon="mdi-identifier"
                :error-messages="errors.employee_code"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="role"
                v-model="form.role_id"
                :items="roles"
                label="Roles *"
                prepend-icon="mdi-account"
                :error-messages="errors.role_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="allCompanies.length > 0">
              <v-autocomplete
                v-model="form.assign_company_id"
                :items="allCompanies"
                label="Assign to Company"
                prepend-icon="mdi-domain"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="supervisor"
                v-model="form.supervisor_id"
                :items="supervisors"
                label="Supervisor"
                prepend-icon="mdi-account"
                :error-messages="errors.supervisor_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="plant"
                v-model="form.plant_id"
                :items="plants"
                label="plant"
                prepend-icon="mdi-account"
                :error-messages="errors.plant_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="contract"
                v-model="form.contract_id"
                :items="contracts"
                label="contract"
                prepend-icon="mdi-account"
                :error-messages="errors.contract_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="department"
                v-model="form.department_id"
                :items="departments"
                label="department"
                prepend-icon="mdi-account"
                :error-messages="errors.department_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="designation"
                v-model="form.designation_id"
                :items="designations"
                label="Designation *"
                prepend-icon="mdi-account"
                :error-messages="errors.designation_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="qualification"
                v-model="form.qualification_id"
                :items="qualifications"
                label="Qualification"
                prepend-icon="mdi-account"
                :error-messages="errors.qualification_id"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="shift"
                v-model="form.shift_id"
                :items="shifts"
                label="shift"
                prepend-icon="mdi-account"
                :error-messages="errors.shift_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-autocomplete
                ref="attendance type"
                v-model="form.attendance_type_id"
                :items="attendance_types"
                label="attendance type"
                prepend-icon="mdi-account"
                :error-messages="errors.attendance_type_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="geolocation"
                v-model="form.geolocation_id"
                :items="geolocations"
                label="Geolocation"
                prepend-icon="mdi-map-marker"
                clearable
                :error-messages="errors.geolocation_id"
              ></v-autocomplete>
            </v-col>

            <!-- <v-col sm="4">
              <v-autocomplete ref="bloodgroup" v-model="form.blood_group_id" :items="bloodgroups" label="Blood Group *"
                prepend-icon="mdi-account" :error-messages="errors.blood_group_id"></v-autocomplete>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field v-model="form.branch" outlined label="Branch" prepend-inner-icon="mdi-bank"></v-text-field>
            </v-col> -->

            <!-- <v-col sm="4">
              <v-text-field v-model="form.pf_no" outlined label="PF No" prepend-inner-icon="mdi-buffet"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.esi_no" outlined label="Esi No" prepend-inner-icon="mdi-buffet"></v-text-field>
            </v-col> -->

            <v-col sm="4">
              <v-text-field
                v-model="form.uid_no"
                outlined
                label="Aadhar No"
                prepend-inner-icon="mdi-buffet"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_name"
                outlined
                label="Emergency Contact Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_contact"
                outlined
                label="Emergency Contact"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_relationship"
                outlined
                label="Emergency Contact Reletion"
                prepend-inner-icon="mdi-account-multiple"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_name_2"
                outlined
                label="Emergency Contact Name 2"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_contact_2"
                outlined
                label="Emergency Contact 2"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.emergency_2_relationship_2"
                outlined
                label="Emergency Contact Relation 2"
                prepend-inner-icon="mdi-account-multiple"
              ></v-text-field>
            </v-col>

            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.pl_leave_count"
                outlined
                label="PL"
                prepend-inner-icon="mdi-city-variant-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.cl_leave_count"
                outlined
                label="CL"
                prepend-inner-icon="mdi-city-variant-outline"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-menu
                v-model="doj_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.doj"
                    label="Date Of Joining"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="doj = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :id="`doj`"
                  v-model="form.doj"
                  @change="doj_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col>
              <v-text-field
                v-model="form.geolocation_lat"
                outlined
                label="Lat"
                prepend-inner-icon="mdi-city-variant"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.geolocation_lng"
                outlined
                label="Lng"
                prepend-inner-icon="mdi-city-variant"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.imei_no"
                outlined
                label="IMEI No"
                prepend-inner-icon="mdi-cellphone-settings"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                v-model="form.active"
                inset
                :label="`Is Active: ${form.active == 1 ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                v-model="form.is_login_logout_tracking"
                inset
                :label="`Is Login-Logout Tracking: ${
                  form.is_login_logout_tracking == 1 ? 'YES' : 'NO'
                }`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                v-model="form.is_always_tracking"
                inset
                :label="`Is 24x7 Tracking: ${
                  form.is_always_tracking == 1 ? 'YES' : 'NO'
                }`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                v-model="form.is_on_probation"
                inset
                color="orange"
                :label="`Probation Period: ${
                  form.is_on_probation ? 'YES' : 'NO'
                }`"
                hint="When ON, the employee cannot apply for leaves on the mobile app."
                persistent-hint
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>

          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save"> Save User </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        active: true,
        doj: "",
      },
      companyId: "",
      doj_menu: false,
      roles: [
        {
          id: 0,
          text: "Select Role",
          value: "",
        },
      ],
      supervisors: [
        {
          id: 0,
          text: "Select Supervisors",
          value: "",
        },
      ],
      designations: [
        {
          id: 0,
          text: "Select Designation",
          value: "",
        },
      ],
      bloodgroups: [{ id: 0, text: "Select Blood Group", value: "" }],
      qualifications: [
        {
          id: 0,
          text: "Select qualification",
          value: "",
        },
      ],
      departments: [
        {
          id: 0,
          text: "Select Department",
          value: "",
        },
      ],
      contracts: [
        {
          id: 0,
          text: "Select Contract",
          value: "",
        },
      ],
      plants: [
        {
          id: 0,
          text: "Select Plant",
          value: "",
        },
      ],
      genders: [
        {
          id: 0,
          text: "Select Gender",
          value: "",
        },
      ],
      attendance_types: [
        {
          id: 0,
          text: "Select Attendance Type",
          value: "",
        },
      ],
      geolocations: [
        {
          id: 0,
          text: "Select Geolocation",
          value: "",
        },
      ],
      shifts: [
        {
          id: 0,
          text: "Select Shift",
          value: "",
        },
      ],
      allCompanies: [],
      isLoading: false,
    };
  },
  mounted() {
    if (this.user.roles[0].name == "SUPERVISOR") {
      this.form.supervisor_id = this.user.id;
    }
    this.getMasters();
    this.getGeolocations();
    this.companyId = this.user.companies[0].id;
    console.log(this.companyId);
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(`users/masters`);
      masters = masters.data;
      // Roles
      masters.roles.forEach((role) => {
        if (this.user.roles[0].name == "SUPERVISOR") {
          if (role.name == "USER") {
            this.roles.push({
              id: role.id,
              text: role.name,
              value: role.id,
            });
          }
        } else if (this.user.roles[0].name == "ADMIN") {
          if (role.name == "USER") {
            this.roles.push({
              id: role.id,
              text: role.name,
              value: role.id,
            });
          }
        } else {
          this.roles.push({
            id: role.id,
            text: role.name,
            value: role.id,
          });
        }
      });
      // Supervisors
      masters.supervisors.forEach((supervisor) => {
        if (this.user.roles[0].name == "SUPERVISOR") {
          if (supervisor.id == this.user.id) {
            this.supervisors.push({
              id: supervisor.id,
              text: supervisor.name,
              value: supervisor.id,
            });
          }
        } else {
          this.supervisors.push({
            id: supervisor.id,
            text: supervisor.name,
            value: supervisor.id,
          });
        }
      });
      //Blood Group
      masters.bloodgroups.forEach((bloodgroup) => {
        this.bloodgroups.push({
          id: bloodgroup.id,
          text: bloodgroup.description,
          value: bloodgroup.id,
        });
      });
      //Designation
      masters.designations.forEach((designation) => {
        this.designations.push({
          id: designation.id,
          text: designation.description,
          value: designation.id,
        });
      });
      //qualifications
      masters.qualifications.forEach((qualification) => {
        this.qualifications.push({
          id: qualification.id,
          text: qualification.description,
          value: qualification.id,
        });
      });
      //departments
      masters.departments.forEach((department) => {
        this.departments.push({
          id: department.id,
          text: department.description,
          value: department.id,
        });
      });
      //contracts
      masters.contracts.forEach((contract) => {
        this.contracts.push({
          id: contract.id,
          text: contract.description,
          value: contract.id,
        });
      });
      //plants
      masters.plants.forEach((plant) => {
        this.plants.push({
          id: plant.id,
          text: plant.description,
          value: plant.id,
        });
      });
      //genders
      masters.genders.forEach((gender) => {
        this.genders.push({
          id: gender.id,
          text: gender.description,
          value: gender.id,
        });
      });
      //attendaanceTypes
      masters.attendanceTypes.forEach((attendanceType) => {
        this.attendance_types.push({
          id: attendanceType.id,
          text: attendanceType.description,
          value: attendanceType.id,
        });
      });
      //shifts
      masters.shifts.forEach((shift) => {
        this.shifts.push({
          id: shift.id,
          text: shift.description,
          value: shift.id,
        });
      });
      // Companies (only for main company)
      if (masters.companies && masters.companies.length > 0) {
        masters.companies.forEach((company) => {
          this.allCompanies.push({
            text: company.name,
            value: company.id,
          });
        });
      }
    },
    async getGeolocations() {
      try {
        let response = await axios.get("/geolocations");
        if (response.data.data) {
          response.data.data.forEach((geolocation) => {
            this.geolocations.push({
              id: geolocation.id,
              text: geolocation.location,
              value: geolocation.id,
            });
          });
        }
      } catch (error) {
        console.error("Error fetching geolocations:", error);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/users", this.form);
        this.isLoading = false;
        this.$router.push("/users");
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>
